import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

export class ProductService {
  static $inject = [
    'RestResource',
    'UtilService',
    '$translate',
    'SessionService',
    'WindowModalService',
  ];

  constructor(
    private RestResource,
    private UtilService,
    private $translate,
    private SessionService,
    private WindowModalService
  ) {}

  utils = new this.UtilService(this);

  apiUrl = environment.apiEndpoint;

  searchProducts(filterCriteria) {
    filterCriteria.company_id = this.SessionService.getSelectedAccountCompany().id;

    let url = this.apiUrl + 'search_products';

    return this.RestResource.request(
      'get',
      url,
      filterCriteria,
      function (response) {
        return response.data;
      },
      function () {
        return false;
      }
    );
  }

  openSearchCabys(item, succesCallBack) {
    let templateUrl = './app/ajs/_shared/components/search-cabys/search-cabys-modal.html';

    let modalParams = {
      item: item,
      title: 'CABYS_CODE',
    };

    let confirmCallback = function (itemObj) {
      return succesCallBack(itemObj);
    };

    this.WindowModalService.open(templateUrl, modalParams, confirmCallback);
  }

  // For ATV
  searchCabys(searchBy) {
    let cabysEnpoint = 'https://api.hacienda.go.cr/fe/cabys?' + searchBy;

    return this.RestResource.request(
      'get',
      cabysEnpoint,
      {},
      function (response) {
        return response.data;
      },
      function () {
        return false;
      }
    );
  }

  // Exonerations
  openProductTaxExoneration(exoneration, tax, product_type, product_id, mode, successCallback) {
    let templateUrl =
      './app/ajs/_shared/components/product-tax-exoneration/modals/product-tax-exoneration-modal.html';

    // let originalItem = angular.copy(exoneration);
    const originalItem = Object.assign({}, exoneration);

    let modalParams = {
      title: 'EXONERATION_DETAILS',
      item: originalItem,
      additionalParams: {
        tax: tax,
        product_type: product_type,
        product_id: product_id,
      },
      mode: mode,
      preventModalClose: true,
    };

    let confirmCallback = (response) => {
      if (exoneration.id) {
        // edit
        exoneration.document_number = response.documentutils_number;
        exoneration.institution_name = response.institution_name;
        exoneration.date = response.date;
        exoneration.percentage = response.percentage;
        exoneration.exoneration_type_code = response.exoneration_type_code;
      }

      this.utils.itemListChanged(tax.id);

      return successCallback(response);
    };

    this.WindowModalService.open(templateUrl, modalParams, confirmCallback);
  }

  saveProductTaxExoneration(exoneration, product_type, product_id) {
    let method = 'post';
    let url = this.apiUrl + 'exonerations';

    if (exoneration.id) {
      // edit
      method = 'put';
      url += '/' + exoneration.id;
    }

    let params = {
      exoneration: exoneration,
      product_type: product_type,
      product_id: product_id,
    };

    return this.RestResource.request(
      method,
      url,
      params,
      (response) => {
        let msg = !exoneration.id ? 'EXONERATION_ADDED' : 'EXONERATION_MODIFIED';
        this.utils._successMsg(this.$translate.instant(msg));

        return response.data;
      },
      function (response) {
        return response.data;
      }
    );
  }

  changeProductTaxExonerationStatus(exoneration, product_type) {
    let url = this.apiUrl + 'exonerations/' + exoneration.id + '?product_type=' + product_type;

    let params = {
      title: '',
      successMsg: '',
    };

    if (exoneration.status) {
      params.title = 'DEACTIVATE_EXONERATION';
      params.successMsg = 'EXONERATION_MODIFIED';
    }

    this.utils.changeItemStatus(url, exoneration, params);
  }

  deleteProductTaxExoneration(exoneration, product_type, successCallback) {
    let url = this.apiUrl + 'exonerations/' + exoneration.id;

    return this.RestResource.request(
      'delete',
      url + '?check_if_used=true',
      {},
      () => {
        let params = {
          title: 'DELETE_EXONERATION',
          // body:       'DELETE_CUSTOM_TAXES_WARNING',
          mode: 'danger',
          requireConfirmation: true,
          successMsg: 'EXONERATION_DELETED',
        };

        this.utils.deleteItem(url + '?product_type=' + product_type, successCallback, params);
      },
      (response) => {
        this.utils.openModalError(response.data.error);
      }
    );
  }

  openDocumentProductTaxesExonerations(documentProduct, currency, scopeType, successCallback) {
    let templateUrl =
      './app/ajs/_shared/components/document-product-taxes-exonerations/modals/document-product-taxes-exonerations-modal.html';

    let modalParams = {
      title: 'EXONERATION_DETAILS',
      item: documentProduct,
      additionalParams: {
        currency: currency,
        scopeType: scopeType,
      },
      preventModalClose: true,
      closeOnSave: true,
    };

    if (documentProduct.transaction_taxes.length > 1) {
      modalParams.closeOnSave = false;
    }

    let confirmCallback = function (documentProductObj) {
      return successCallback(documentProductObj);
    };

    this.WindowModalService.open(templateUrl, modalParams, confirmCallback);
  }
}
